import { render, staticRenderFns } from "./modelRunurgent.vue?vue&type=template&id=4891b2f1&scoped=true&"
import script from "./modelRunurgent.vue?vue&type=script&lang=js&"
export * from "./modelRunurgent.vue?vue&type=script&lang=js&"
import style0 from "./modelRunurgent.vue?vue&type=style&index=0&id=4891b2f1&lang=scss&scoped=true&"
import style1 from "./modelRunurgent.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4891b2f1",
  null
  
)

export default component.exports